import { render, staticRenderFns } from "./ShareGarden.vue?vue&type=template&id=56889a50&scoped=true&"
import script from "./ShareGarden.vue?vue&type=script&lang=js&"
export * from "./ShareGarden.vue?vue&type=script&lang=js&"
import style0 from "./ShareGarden.vue?vue&type=style&index=0&id=56889a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56889a50",
  null
  
)

export default component.exports